const INITIAL_STATE = {
  filtros: [
    {
      namePagina: "",
      campos: [{ key: "", value: "" }],
    },
  ],
};

function setFiltros(state, action) {
  const { value: filtroPagina } = action;

  if (filtroPagina == null) {
    return {
      ...state,
      filtros: [],
    };
  }

  if (state.filtros.some((element) => element.namePagina === filtroPagina.namePagina)) {
    return {
      ...state,
      filtros: state.filtros.map((pFiltro) => {
        if (pFiltro.namePagina === filtroPagina.namePagina) {
          return { ...filtroPagina };
        }
        return { ...pFiltro };
      }),
    };
  } else {
    return {
      ...state,
      filtros: [...state.filtros, { ...filtroPagina }],
    };
  }
}

function filtroReducer(state = INITIAL_STATE, action) {
  if (action.type === "setFiltros") {
    return setFiltros(state, action);
  }
  return state;
}

export default filtroReducer;
